import React, {
  useRef,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from "react";
import styled from "styled-components";
import AllPatientsTable from "../components/AllPatientsTable";
import PatientDetails from "../components/PatientDetails";

const Container = styled.div`
  display: flex;
  max-height: calc(100vh - 80px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftContainer = styled.div`
  background-color: #141B25;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0px 4px 6px 0px #00000040;
  display: grid;
  place-items: center;
  font-size: 16px;
  color: white;
  overflow: auto;
  min-width: 100px;
`;

const RightContainer = styled.div`
  background-color: #000;
  border: 4px solid #0088CF;
  border-radius: 6px;
  box-shadow: 0px 4px 6px 0px #00000040;
  display: grid;
  place-items: center;
  font-size: 16px;
  color: white;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #1f2a36;
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border: 1px solid #3e526a;
    border-radius: 100px;
  }
`;

const Resizer = styled.div`
  width: 12px;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: background-color 0.15s ease-in-out;

  &:hover,
  &.dragging {
    background-color: #c0c0c0;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Home = ({
  setActiveTab,
  setIframeUrl,
  selectedPatient,
  setSelectedPatient,
  openIframeViewer,
}) => {
  const [leftContainerWidth, setLeftContainerWidth] = useState(550);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);
  const [toolbarWidth, setToolbarWidth] = useState(0);

  useEffect(() => {
    setToolbarWidth(parseInt(localStorage.getItem("toolbarWidth") || "0"));
  }, []);

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDragging) return;
      const newWidth =
        e.clientX - containerRef.current.getBoundingClientRect().left;
      if (newWidth >= 100) {
        setLeftContainerWidth(newWidth);
      }
    },
    [isDragging]
  );

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove]);

  const handleToggleView = (showTable) => {
    setLeftContainerWidth(showTable ? 400 : 100);
  };

  const computedContainerWidth = useMemo(() => {
    return toolbarWidth ? toolbarWidth - leftContainerWidth - 90 : 0;
  }, [leftContainerWidth, toolbarWidth]);

  return (
    <Container ref={containerRef}>
      <LeftContainer style={{ width: `${leftContainerWidth}px` }}>
        <AllPatientsTable
          onSelectPatient={setSelectedPatient}
          selectedPatient={selectedPatient}
          onToggleView={handleToggleView}
          setActiveTab={setActiveTab}
          setIframeUrl={setIframeUrl}
        />
      </LeftContainer>
      <Resizer
        style={{
          width: "8px",
        }}
        onMouseDown={handleMouseDown}
        className={isDragging ? "dragging" : ""}
      />
      <RightContainer style={{ width: `${computedContainerWidth}px` }}>
        <PatientDetails
          patient={selectedPatient}
          setSelectedPatient={setSelectedPatient}
          // containerWidth={computedContainerWidth}
          openIframeViewer={openIframeViewer}
        />
      </RightContainer>
    </Container>
  );
};

export default Home;
